import { useDispatch, useSelector } from "react-redux";
import CourseCardComponentB2c from "./CourseCardComponentB2c";
import { useCallback, useEffect, useState } from "react";
import { getProductCategories } from "../../redux/courses/actions";
import { SessionKeys, getStepIndex } from "../../utils/AppUtils";
import _ from "lodash";
import Loader from "../Loader/Loader";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
// import FilterAndSearchSection from "./FilterAndSearchSection";
import CourseListingMainComponent from "./CourseListingMainComponent";
import LPListingContentComponent from "../NewDesign/ListingContent/LPListingContent/LPListingContentComponent";
import useLogin from "../../custom-hooks/useLogin";
import { useNavigate } from "react-router-dom";
import NewCourseListingMainComponent from "./NewCourseListingMainComponent";
import { setJoyRideReq } from "../../redux/assignCourse/actions";
import { useTranslation } from "react-i18next";

const LPListLearnComp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn, userData } = useLogin();
  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let providerId = "";
  let allPartners = "";
  let providerName = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    providerId = paramsReq.provider_id;
    allPartners = paramsReq?.allPartners;
    providerName = paramsReq?.provider_name;
  }
  // const providerId = params.get("provider_id");
  const tab = params.get("tab");
   const {t} = useTranslation();
  const [key, setKey] = useState("");

  useEffect(() => {
    console.log("Tab: ", tab);
    if (tab === "3" || tab ==="6") { //added tab==="6"
      setKey("all-non-oblp");
    } else if (tab === "4") {
      setKey("my-non-oblp");
    } else if (tab === "5") {
      setKey("my-oblp");
    }
  }, [tab]);

  const showMyOnboard = useCallback(() => {
    if (!_.isEmpty(userData.role)) {
      console.log(userData.role);
      if (!userData.role.includes("customer")) return true;
    }
    return false;
  }, [userData]);

  const renderLPComp = () => {
    if (key === "all-non-oblp" || key === "my-non-oblp" || key === "my-oblp") {
      console.log(key);
      return (
        <LPListingContentComponent
          isAllLP={key === "all-non-oblp"}
          isMyOBLP={key === "my-oblp"}
          isMyLP={key === "my-non-oblp"}
          tabKey={key}
        />
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);

  const renderTitle = () => {
    return (
    <div dangerouslySetInnerHTML={{__html: allPartners
      ? `Action Paths from ${authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
                authBroker?.payload?.user?.config?.partner_menu_text?.toLowerCase():
                "partners"}`
      : providerName
      ? `Action Paths from ${providerName}`
      : t("allLearningPath")}}></div>
    )
}


  return (
    <>
      <div className="contsection">
        <nav>
          <div className="nav-section-box" id="nav-tab" role="tablist">
            <Tabs
              underline
              activeKey={key}
              onSelect={(k) => {
                // setIsFetching(true)
                console.log("selectKey: ", k);
                if(allPartners || providerName) {

                }
                else if (k === "all-non-oblp") {
                  navigate("/learn/learningpath?tab=3");
                } else if (k === "my-non-oblp") {
                  navigate("/learn/learningpath?tab=4");
                } else if (k === "my-oblp") {
                  navigate("/learn/learningpath?tab=5");
                } else setKey(k);
                // setVideoListing(CONFIG.INITIAL_PRODUCT_CARD_DATA)
              }}
            >
              {
                <Tab
                  eventKey={"all-non-oblp"}
                  title={
                    renderTitle()
                  }
                >
                  {key === "all-non-oblp" && renderLPComp()}
                </Tab>
              }
              {isLoggedIn && !providerId && !allPartners && (
                <Tab eventKey={"my-non-oblp"} title= {t('myLearningPath')}>
                  {key === "my-non-oblp" && renderLPComp()}
                </Tab>
              )}
              {isLoggedIn &&
                !providerId &&
                showMyOnboard &&
                userRole !== "customer" &&
                !allPartners && (
                  <Tab eventKey={"my-oblp"} title={t('myOnboardingPath')}>
                    {key === "my-oblp" && renderLPComp()}
                  </Tab>
                )}
            </Tabs>
          </div>
        </nav>
      </div>
    </>
  );
};
export default LPListLearnComp;
